import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';

/**
 * User data interface
 */
interface UserData {
    /**
     * User Id
     */
    userId: string;

    /**
     * User name
     */
    username: string;

    /**
     * Name
     */
    name?: string;

    /**
     * Email
     */
    email: string;

    /**
     * Business Id
     */
    businessId: string;

    /**
     * Company Id
     */
    companyId?: string;

    /**
     * Company name
     */
    companyName?: string;

    /**
     * Company type
     */
    companyType?: string;

    /**
     * User roles
     */
    roles?: string[];
}

/**
 * Profile service for getting user information and fill user data and inline manual user settings
 */
@Injectable()
export class ProfileService {
    /**
     * User data
     */
    private userData: UserData;

    /**
     * Mock profile
     */
    private mockProfile: boolean;

    /**
     * Check is user logged (if userData is not empty)
     * @returns {boolean}
     */
    public isLogged(): boolean {
        return !!this.userData;
    }

    /**
     * Is mock profile
     * @returns {boolean}
     */
    public isMockProfile(): boolean {
        return this.mockProfile;
    }

    /**
     * Get user name
     * @returns {string}
     */
    public getUserName(): string {
        return JSON.parse(localStorage.getItem('user')).username;
    }

    /**
     * Init inline manual settings
     */
    public initInlineManualSettings() {
        (window as any).inlineManualTracking = {
            uid: this.userData.username,
            email: this.userData.email,
            username: this.userData.username,
            name: this.userData.name,
            group: this.userData.companyId + '; ' + this.userData.companyName,
            plan: this.userData.companyType ? this.userData.companyType : 'Shipper'
        };
    }

    /**
     * Load mock profile for 'mock' env
     */
    public loadMockProfile(login: string): void {
        this.mockProfile = true;
        this.userData = {
            businessId: '1',
            email: 'user@gmail.com',
            userId: '1',
            username: login,
            name: 'User Name',
            companyId: '1',
            companyName: 'Company name',
            companyType: 'SHIPPER',
            roles: [
                'SHIPPERTMS_CO_USER',
                'SHIPPERTMS_ROUTE_USER',
                'SHIPPERTMS_CO_USER',
                'SHIPPERTMS_SLOT_USER',
                'SLOT_USER',
                'SHIPPERTMS_DOC_USER',
                'SHIPPERTMS_COST_USER',
                'WKTSADMIN_SUPERUSER']
        };
        console.log(this.userData);
        this.initInlineManualSettings();
    }
}



// WEBPACK FOOTER //
// ./src/app/services/security/profile.service.ts